import { Injectable, NgModule } from "@angular/core";
import { Session_ePaySessionModel } from "../Models/Model/Session_ePaySessionModel";
import { Session_ePaySessionWebApi } from "../Service/WebApi/Session_ePaySessionWebApi";
import { FormWebApi } from "./WebApi/FormWebApi";
import { each } from 'lodash-es';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/*@NgModule({
  providers: [FormWebApi, Session_ePaySessionWebApi]
})*/
export class ePayService {
  public token: string = '';

  constructor(private _ePaySessionWebApi: Session_ePaySessionWebApi, private formWebApi: FormWebApi) {
  }

  public ePay: Session_ePaySessionModel | null | undefined;
  public sessionId: string | null | undefined;

  //Get the iFrame
  iFrame = (): string => {
    var _iframe = '';
    console.info('iframe source', this.ePay);
    if (this.ePay) {
      if (this.ePay.paymentPage) {
        if (this.ePay.paymentPage.credit_card) {
          if (this.ePay.paymentPage.credit_card.length > 0) {
            each(this.ePay.paymentPage.credit_card, (data: Session_Credit_Card_RequestModel) => {
              console.log('iframe', data);
              if (data.snappay?.processor) {
                _iframe = data.snappay.processor;
              }
              if (data.cardconnect?.processor) {
                console.log('cardconnect', data.cardconnect.processor);
                _iframe = data.cardconnect.processor;
              }
            });
          }
        }
      }
    }
    console.info('iframe source', _iframe);
    return _iframe;
  }

  GenerateRequestId = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.generateRequestId(this.ePay);
    }
    else {
      return new Observable<string>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Get the origin of card connect
  Processor = () => {
    var _Origin = '';
    if (this.ePay) {
      if (this.ePay.paymentPage) {
        if (this.ePay.paymentPage.credit_card) {
          if (this.ePay.paymentPage.credit_card.length > 0) {
            each(this.ePay.paymentPage.credit_card, (data: Session_Credit_Card_RequestModel) => {
              if (data.cardconnect?.processor) {
                _Origin = data.cardconnect.processor;
              }
              if (data.snappay?.processor) {
                _Origin = data.snappay.processor;
              }
            });
          }
        }
      }
    }
    return _Origin;
  }

  //Get the origin of card connect
  Origin = () => {
    var _Origin = '';
    if (this.ePay) {
      if (this.ePay.paymentPage) {
        if (this.ePay.paymentPage.credit_card) {
          if (this.ePay.paymentPage.credit_card.length > 0) {
            each(this.ePay.paymentPage.credit_card, (data: Session_Credit_Card_RequestModel) => {
              if (data.cardconnect?.origin) {
                _Origin = data.cardconnect.origin;
              }
              if (data.snappay?.origin) {
                _Origin = data.snappay.origin;
              }
            });
          }
        }
      }
    }
    return _Origin;
  }

  //Load the session
  Load = (sessionId: string, iFrame: boolean) => {
    return this.formWebApi.session_Live(sessionId, iFrame);
  }

  //Get the next page
  NextPage = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.getNextPage(this.ePay);
    }
  }

  //Calculate the payment amount
  CalcuatePaymentAmount = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.caclulateAmount(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Refresh the sessin
  refresh = (sessionId: string, config: string) => {
    return this._ePaySessionWebApi.refresh(sessionId, config);
  }

  //Save the payment
  savePayment = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.sendPayment(this.ePay);
    } else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Unstore the payment
  UnStore = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.unStore(this.ePay);
    } else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Post the payment
  postApplePay = (navigateUrl: string) => {
    if (this.ePay) {
      this.ePay.apple.navigateUrl = navigateUrl;
      return this._ePaySessionWebApi.postApplePay(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Post the payment
  postGooglePay = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.postGooglePay(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  deviceConnect(hsn: string | null) {
    if (this.ePay) {
      return this.formWebApi.deviceConnect(this.ePay, hsn);
    }
    else {
      return new Observable<Object>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  deviceCharge() {
    if (this.ePay) {
      return this.formWebApi.deviceCharge(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  manualCharge() {
    if (this.ePay) {
      return this.formWebApi.manualCharge(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  deviceCancelRequest() {
    if (this.ePay) {
      return this.formWebApi.deviceCancelRequest(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }
}


/*
         * @ngdoc function
         * @name ePay.WebApi:AccountTypeWebApi
         * @description
         * Web Api Service
         
import { Injectable, PACKAGE_ROOT_URL } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Session_ePaySessionModel } from "../Models/Model/Session_ePaySessionModel";
import { Session_ePaySessionWebApi } from "../Service/WebApi/Session_ePaySessionWebApi";
import { FormWebApi } from "./WebApi/FormWebApi";
import { each } from 'lodash-es';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';
import { Observable } from 'rxjs';

@Injectable()
export class ePayService {
  public token: string = '';

  constructor(private http: HttpClient, private _ePaySessionWebApi: Session_ePaySessionWebApi) {
  }

  public ePay: Session_ePaySessionModel | null | undefined;
  public sessionId: string | null | undefined;

  //Get the iFrame
  iFrame = (): string => {
    var _iframe = '';
    if (this.ePay) {
      if (this.ePay.paymentPage) {
        if (this.ePay.paymentPage.credit_card) {
          if (this.ePay.paymentPage.credit_card.length > 0) {
            each(this.ePay.paymentPage.credit_card, (data: Session_Credit_Card_RequestModel) => {
              if (data.snappay.processor) {
                _iframe = data.snappay.processor;
              }
              if (data.cardconnect.processor) {
                _iframe = data.cardconnect.processor;
              }
            });
          }
        }
      }
    }
    console.info('iframe source', _iframe);
    return _iframe;
  }

  GenerateRequestId = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.generateRequestId(this.ePay);
    }
    else {
      return new Observable<string>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Get the origin of card connect
  Origin = () => {
    var _Origin = '';
    if (this.ePay) {
      if (this.ePay.paymentPage) {
        if (this.ePay.paymentPage.credit_card) {
          if (this.ePay.paymentPage.credit_card.length > 0) {
            each(this.ePay.paymentPage.credit_card, (data: Session_Credit_Card_RequestModel) => {
              if (data.cardconnect.processor) {
                _Origin = data.cardconnect.processor;
              }
              if (data.snappay.processor) {
                _Origin = data.snappay.processor;
              }
            });
          }
        }
      }
    }
    return _Origin;
  }

  //Load the session
  Load = (sessionId: string, iFrame: boolean) => {
    let formWebApi = new FormWebApi(this.http);
    return formWebApi.session_Live(sessionId, iFrame);
  }

  //Get the next page
  NextPage = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.getNextPage(this.ePay);
    }
  }

  //Calculate the payment amount
  CalcuatePaymentAmount = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.caclulateAmount(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Refresh the sessin
  refresh = (sessionId: string, config: string) => {
    return this._ePaySessionWebApi.refresh(sessionId, config);
  }

  //Save the payment
  savePayment = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.sendPayment(this.ePay);
    } else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Unstore the payment
  UnStore = () => {
    if (this.ePay) {
      return this._ePaySessionWebApi.unStore(this.ePay);
    } else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  //Post the payment
  postApplePay = (navigateUrl: string) => {
    if (this.ePay) {
      this.ePay.apple.navigateUrl = navigateUrl;
      return this._ePaySessionWebApi.postApplePay(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  deviceConnect(hsn: string | null) {
    if (this.ePay) {
      let formWebApi = new FormWebApi(this.http);
      return formWebApi.deviceConnect(this.ePay, hsn);
    }
    else {
      return new Observable<Object>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  deviceCharge() {
    if (this.ePay) {
      let formWebApi = new FormWebApi(this.http);
      return formWebApi.deviceCharge(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  manualCharge() {
    if (this.ePay) {
      let formWebApi = new FormWebApi(this.http);
      return formWebApi.manualCharge(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }

  deviceCancelRequest() {
    if (this.ePay) {
      let formWebApi = new FormWebApi(this.http);
      return formWebApi.deviceCancelRequest(this.ePay);
    }
    else {
      return new Observable<Session_ePaySessionModel>(observer => {
        // You can either emit nothing and complete:
        observer.complete();
      });
    }
  }
}
*/
